(function () {
  let currentOpenId = null;
  let prevOverflowBody = '';
  let prevOverflowHtml = '';
  let savedScrollY = 0;

  function setVideoSrcIfNeeded(videoEl) {
    if (!videoEl) return;
    const srcEl = videoEl.querySelector('source');
    if (srcEl && !srcEl.getAttribute('src')) {
      const lazy = srcEl.getAttribute('data-src');
      if (lazy) {
        srcEl.setAttribute('src', lazy);
        try { videoEl.load(); } catch (_) {}
      }
    }
  }

  function lockScroll() {
    savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;

    prevOverflowBody = document.body.style.overflow;
    prevOverflowHtml = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.width = '100%';

    document.body.classList.add('is-modal-open');
    document.documentElement.classList.add('is-modal-open');

    document.body.classList.remove('overflow-auto','overflow-scroll','overflow-visible');
    document.documentElement.classList.remove('overflow-auto','overflow-scroll','overflow-visible');
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
  
    document.body.style.overflow = prevOverflowBody || '';
    document.documentElement.style.overflow = prevOverflowHtml || '';
    document.body.classList.remove('is-modal-open','overflow-hidden','fixed');
    document.documentElement.classList.remove('is-modal-open','overflow-hidden','fixed');
  
  
    const html = document.documentElement;
    const prevScrollBehavior = html.style.scrollBehavior; 
    html.style.scrollBehavior = 'auto';
  
    window.scrollTo(0, savedScrollY);
  
    requestAnimationFrame(() => {
      html.style.scrollBehavior = prevScrollBehavior || '';
    });
  }

  function openModal(id) {
    const modal = document.getElementById(id);
    if (!modal) return;

    modal.classList.remove('dy:hidden');
    modal.setAttribute('aria-hidden', 'false');
    currentOpenId = id;

    lockScroll();

    const video = modal.querySelector('video');
    setVideoSrcIfNeeded(video);
    if (video) { try { video.play(); } catch (_) {} }
  }

  function closeModal(id) {
    const modal = document.getElementById(id);
    if (!modal) return;

    modal.classList.add('dy:hidden');
    modal.setAttribute('aria-hidden', 'true');

    const video = modal.querySelector('video');
    if (video) { try { video.pause(); } catch (_) {} video.currentTime = 0; }

    currentOpenId = null;
    unlockScroll();
  }

  function getOpenModal() {
    if (!currentOpenId) return null;
    return document.getElementById(currentOpenId);
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openModal(opener.getAttribute('data-open'));
      return;
    }
    const openModalEl = getOpenModal();
    if (openModalEl) {
      if (e.target.closest('video')) return;
      closeModal(openModalEl.id);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const openModalEl = getOpenModal();
      if (openModalEl) closeModal(openModalEl.id);
    }
  });
})();
